<template>

<app-page v-if="is.loaded" :title="page.title">

    <com-list />

</app-page>

</template>

<script>

import mixinPage from '@/mixin/page.js'

import comList from './events/List'

export default {

    mixins: [mixinPage],

    components: {
        'com-list': comList
    }

}

</script>

<style scoped>

</style>
